let manager_id = null;

const initManagerSelect = (element) => {
  const $element = $(element);
  const managersPath = element.dataset.managersPath;
  const accountType = element.dataset.accountType;
  const manager = element.dataset.manager;

  destroySelect2($element);

  $element.select2({
    theme: 'bootstrap4',
    width: '100%',
    allowClear: true,
    ajax: {
      url: managersPath,
      dataType: 'json',
      data(params) {
        return {
          q: params.term,
          select_2_extra: accountType
        };
      }
    }
  });

  if (manager != 'null' && manager != null && manager !== undefined) {
    const json = JSON.parse(manager);
    const name = `${json.name} - ${json.document_number}`;
    const id = parseInt(json.id, 10);
    $element.select2('trigger', 'select', {
      data: { id, text: name }
    });
  }
};

const initFundSelect = (element) => {
  const $element = $(element);
  const fundsPath = element.dataset.fundsPath;
  const accountType = element.dataset.accountType;
  const fund = element.dataset.fund;
  const allFunds = element.dataset.allFunds;

  destroySelect2($element);

  $element.select2({
    theme: 'bootstrap4',
    width: '100%',
    allowClear: true,
    ajax: {
      url: fundsPath,
      dataType: 'json',
      data(params) {
        const queryParameters = {
          q: params.term,
          select_2_extra: accountType,
          manager_id: manager_id || null
        };

        if (allFunds === '1') {
          queryParameters.all_funds = true;
        }

        return queryParameters;
      }
    }
  });

  if (fund != 'null' && fund != undefined && fund != null) {
    const json = JSON.parse(fund);
    const name = `${json.name} - ${json.document_number}`;
    const id = parseInt(json.id, 10);
    $element.select2('trigger', 'select', {
      data: { id, text: name }
    });
  }
};

window.initializeManagerAndFundSelects = function initializeManagerAndFundSelects(root) {
  const $root = root ? $(root) : $(document);

  $root.find('.JS-managers:visible').each((_index, element) => {
    initManagerSelect(element);
  });

  $root.find('.JS-funds-2:visible').each((_index, element) => {
    initFundSelect(element);
  });
};

onLoad(($) => {
  const hasManagers = $('.JS-managers').length > 0;
  const hasFunds = $('.JS-funds-2').length > 0;

  if (!hasManagers && !hasFunds) return;

  $(document).off('change.managerSelect', '.JS-managers');
  $(document).on('change.managerSelect', '.JS-managers', function () {
    manager_id = $(this).val();
  });

  initializeManagerAndFundSelects();
});
